"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { IntegrationAppConnectionContext } from './use-integration-app-connection.mjs';

const IntegrationAppConnectionProvider = ({ connectionId, children }) => {
  const value = useMemo(() => ({ connectionId }), [connectionId]);
  return /* @__PURE__ */ jsx(IntegrationAppConnectionContext.Provider, { value, children });
};

export { IntegrationAppConnectionProvider };
